import { type FunctionComponent, useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { useSearchContext } from "scmp-app/components/search/contexts";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { SearchEvent } from "scmp-app/components/tracking/google-analytics-4/types";
import type { itemTopicsCardItemTopic$key } from "scmp-app/queries/__generated__/itemTopicsCardItemTopic.graphql";

import { StyledEntityLink } from "./styles";

type Props = {
  className?: string;
  reference: itemTopicsCardItemTopic$key;
};

export const TopicsCardItem: FunctionComponent<Props> = ({ className, reference }) => {
  const topic = useFragment(
    graphql`
      fragment itemTopicsCardItemTopic on Topic {
        entityId
        name
        ...entityLink
      }
    `,
    reference,
  );

  const { currentValue, initialSearchId } = useSearchContext();

  const handleTopicClick = useCallback(() => {
    // GA4 21.2.1
    sendGA4Tracking({
      action: "click",
      category: "search",
      customized_parameters: {
        search_id: initialSearchId,
        search_text: currentValue,
        topic_id: topic.entityId,
      },
      subcategory: "result",
    } as SearchEvent);
  }, [currentValue, initialSearchId, topic.entityId]);

  return (
    <StyledEntityLink className={className} onClick={handleTopicClick} reference={topic}>
      {topic.name}
    </StyledEntityLink>
  );
};

TopicsCardItem.displayName = "TopicsCardItem";
